module.exports = __webpack_public_path__ + "img/screenLeft.c12a9dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medi-mass/screenLeft.jpg
// module id = 616
// module chunks = 5